/* Publish by EComposer at 2026-10-21 05:09:19*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-o676v4puork"]=  window.__ectimmers["ecom-o676v4puork"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-o676v4puork').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o676v4puork', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uugkyawcae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uugkyawcae', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sy3atgt62ji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sy3atgt62ji', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gx3zbbnyqjj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gx3zbbnyqjj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ow8q4mz53dk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ow8q4mz53dk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vp1u88cr9f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vp1u88cr9f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whnjx4v1z39').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whnjx4v1z39', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nv55q20919a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nv55q20919a', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-orvsljhtgm"]=  window.__ectimmers["ecom-orvsljhtgm"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-orvsljhtgm"]["crjnduv1l"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-orvsljhtgm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orvsljhtgm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2ixz7vucqo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2ixz7vucqo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yj3ycqj1hv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yj3ycqj1hv', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s512fml9pwc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s512fml9pwc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwhrslnxnhf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwhrslnxnhf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iln05ecwq8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iln05ecwq8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qd5wjiod0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qd5wjiod0t', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            